<template>
  <div class="home">
    <Control/>
  </div>
</template>

<script>
import Control from '@/components/Control';

export default {
  name: 'Home',
  components: {
    Control
  }
}
</script>

<style>
  body {
    overflow: hidden;
    margin: 0;
  }
</style>
